export default __webpack_public_path__ + "static/media/card-5.f4841e38.webp";